<section class="flex flex-col gap-4">
  <h3 class="text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 ">The Technology: Atomo AI At Work</h3>

  <div class="grid grid-cols-12 gap-3">
    <div class="col-span-12 md:col-span-6 lg:col-span-4 p-2 flex flex-col gap-3 rounded-md medium_box_shadow">
      <figure class="h-[300px] flex justify-center items-center bg-sky_lightest">
        <img src="../../../../assets/images/learning-path-ways.webp" alt="Individualized Learning Pathways"
          class="object-cover h-full w-full">
      </figure>
      <h4 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 font-semibold text-center">Individualized Learning
        Pathways</h4>
      <p class="text-hurrey-12 md:text-hurrey-16 lg:text-hurrey-20 text-ink_light">Atomo's AI engine analyzes individual
        student knowledge levels and adapts content in real-time, creating customized learning experiences that
        traditional instruction cannot achieve at scale.</p>
    </div>
    <div class="col-span-12 md:col-span-6 lg:col-span-4 p-2 flex flex-col gap-3 rounded-md medium_box_shadow">
      <figure class="h-[300px] flex justify-center items-center">
        <img src="../../../../assets/images/intelligent-feedback-systems.webp" alt="Intelligent Feedback
        Mechanisms" class="object-cover h-full w-full">
      </figure>
      <h4 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 font-semibold text-center">Intelligent Feedback
        Mechanisms</h4>
      <p class="text-hurrey-12 md:text-hurrey-16 lg:text-hurrey-20 text-ink_light">Our precision-driven feedback loop
        addresses unique student needs through error analysis and tailored guidance, ensuring no learner is left behind.
      </p>
    </div>


    <div class="col-span-12 md:col-span-6 lg:col-span-4 p-2 flex flex-col gap-3 rounded-md medium_box_shadow">
      <figure class="h-[300px] flex justify-center items-center">
        <img src="../../../../assets/images/teacher-tools.webp" alt="Teacher Empowerment Tools"
          class="object-cover h-full w-full">
      </figure>
      <h4 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 font-semibold text-center">Teacher Empowerment Tools
      </h4>
      <p class="text-hurrey-12 md:text-hurrey-16 lg:text-hurrey-20 text-ink_light">Atomo doesn't replace educators it
        amplifies their impact. Teachers receive real-time analytics, automated grading support, and data-driven
        insights to identify students requiring additional attention.
      </p>
    </div>

  </div>


</section>
